import { experimentsWrapper, window } from '@wix/photography-client-lib';
import { HttpClient } from '@wix/http-client';
import { GALLERY_v4_CONSTS } from '@wix/photography-client-lib';
export var addGalleryToAutofixDB = function (args) {
    var _a, _b, _c;
    var viewMode = args.viewMode, wixStyles = args.wixStyles, galleryId = args.galleryId, dimensions = args.dimensions;
    if (viewMode !== GALLERY_v4_CONSTS.viewMode.SITE)
        return;
    try {
        var isAutofixGalleryAdditionExpIsOn = experimentsWrapper.getExperimentBoolean('specs.pro-gallery.autofixGalleriesAddition');
        var isTemplate = (_c = (_b = (_a = window.parent) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.href) === null || _c === void 0 ? void 0 : _c.includes('https://www.wix.com/website-template/view/html');
        if (isAutofixGalleryAdditionExpIsOn &&
            isTemplate &&
            wixStyles &&
            dimensions) {
            var serverlessPath = 'https://www.wix.com/_serverless/pro-gallery-autofix-service/';
            var endpoint = 'autofix-add-gallery';
            var httpClient = new HttpClient();
            httpClient.request({
                url: serverlessPath + endpoint,
                method: 'POST',
                data: JSON.stringify({
                    galleryOptions: wixStyles,
                    galleryId: galleryId,
                    dimensions: dimensions,
                    version: 3,
                }),
                headers: {
                    'content-Type': 'application/json',
                    accept: 'application/json',
                },
            });
        }
    }
    catch (err) {
        console.error(err);
    }
};
//# sourceMappingURL=autofixHelper.js.map